import ApprovalIcon from "../../assets/icons/svg/ReviewTickMark.svg";
import InProgressIcon from "../../assets/icons/svg/ReviewInProgressIcon.svg";
import PendingIcon from "../../assets/icons/svg/ReviewPendingIcon.svg";
import RevokedIcon from "../../assets/icons/svg/ReviewRevokeIcon.svg";
import RightArrow from "../../assets/icons/svg/lineWithRightArrow.svg";
import LeftArrow from "../../assets/icons/svg/lineWithLeftArrow.svg";
import BypassLevel from "../../assets/icons/svg/BypassLevel.svg";
import { getApprovalStagesToShow } from "./ReviewsHelper";

function ReviewStageTransitionChart({
  approvalStages,
  isRollback = false,
  skipReviewTillLevel,
  rollbackReviewToLevel,
}) {
  const { showStartLine, showEndLine, approvalStagesToShow, isReviewInitiated, willReviewClose } =
    getApprovalStagesToShow(approvalStages, isRollback, skipReviewTillLevel, rollbackReviewToLevel);

  function getTargetIndex(approvalStagesToShow) {
    if (isRollback) {
      return -1;
    }

    const approvalStageInProgressIndex = approvalStagesToShow.findIndex(
      (record) => record.clearanceStatus === "in_progress",
    );

    if (approvalStageInProgressIndex === -1 && !isReviewInitiated) {
      return 0;
    }

    if (approvalStageInProgressIndex !== -1) {
      return approvalStageInProgressIndex + 1;
    }

    return -1;
  }

  const targetIndex = getTargetIndex(approvalStagesToShow);

  const mapper = (rollbackTo, index) => ({
    approved: {
      icon: ApprovalIcon,
      textStyle: { color: "#666A84" },
      parentClass: isRollback && rollbackTo ? "" : "opacity-50",
    },
    in_progress: {
      icon: InProgressIcon,
      textStyle: { color: "#192048" },
      parentClass: "",
    },
    pending: {
      icon: PendingIcon,
      textStyle: index === targetIndex ? { color: "#192048" } : { color: "#666A84" },
      parentClass: index === targetIndex ? "opacity-100" : "opacity-50",
    },
    revoked: {
      icon: RevokedIcon,
      textStyle: { color: "#192048" },
    },
    bypassed: {
      icon: BypassLevel,
      textStyle: { color: "#666A84" },
      parentClass: isRollback && rollbackTo ? "" : "opacity-50",
    },
  });

  const getConnectorType = ({ rollbackTo, clearanceStatus, index }) => {
    let showLeftArrow = false;
    let showRightArrow = false;
    let showStandardConnector = false;

    if (index === approvalStagesToShow.length - 1) {
      showLeftArrow = false;
      showRightArrow = false;
      showStandardConnector = false;
    } else if (!isRollback) {
      showLeftArrow = false;
      showRightArrow = ["in_progress"].includes(clearanceStatus);
      showStandardConnector = ["approved", "pending", "bypassed"].includes(clearanceStatus);
    } else {
      showLeftArrow = rollbackTo && ["approved", "bypassed"].includes(clearanceStatus);
      showRightArrow = false;
      showStandardConnector = !rollbackTo;
    }

    return {
      showLeftArrow,
      showRightArrow,
      showStandardConnector,
    };
  };

  return (
    <div className="flex flex-row items-center gap-6">
      {!isReviewInitiated ? (
        <div className="flex flex-row gap-4">
          <img src={InProgressIcon} />
          <img src={RightArrow} />
        </div>
      ) : undefined}
      {isReviewInitiated && showStartLine && (
        <p className=" w-16 border-b-2 border-dashed border-system_colour_45 opacity-50" />
      )}
      {approvalStagesToShow.map((stage, index) => {
        const { clearanceStatus, serial, rollbackTo } = stage;
        const { parentClass, icon, textStyle } = mapper(rollbackTo, index)[clearanceStatus];
        const { showLeftArrow, showRightArrow, showStandardConnector } = getConnectorType({
          rollbackTo,
          clearanceStatus,
          index,
          rollbackReviewToLevel,
        });

        return (
          <div key={index} className="flex flex-row items-center gap-4">
            <div className={`flex flex-row items-center gap-2 ${parentClass}`}>
              <img src={icon} />
              <p style={textStyle} className="text-base font-normal">{`Level ${serial}`}</p>
            </div>
            {showLeftArrow && <img src={LeftArrow} />}
            {showRightArrow && <img src={RightArrow} />}
            {showStandardConnector && <p className="w-16 border-b-2 border-system_colour_45 opacity-50" />}
          </div>
        );
      })}
      {isReviewInitiated && showEndLine && (
        <p className=" w-16 border-b-2 border-dashed border-system_colour_45 opacity-50" />
      )}
      {willReviewClose ? (
        <div className="flex flex-row gap-4">
          <img src={RightArrow} />
          <img src={ApprovalIcon} />
        </div>
      ) : undefined}
      {showEndLine && <p className="border-b-2 border-dashed border-system_colour_45 opacity-50 my-auto" />}
    </div>
  );
}

export default ReviewStageTransitionChart;
